import {Component} from '../../core';
import constants from '../../cityConstant.js';
import {isSet,seoUrl,isEmpty} from '../../utils/common';

/**
 * Coworkhome Offers component
 */
export class CoworkOffersComponent extends Component {

    static alias = 'cowork-home-offers';

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {

        // Initialize the offers
        this.initializeOffers();
    }

    initializeOffers(){
        let cityId = '';
        if(globals.cityId != 1) {
            cityId = globals.cityId;
        }
        this.fetchOffers(cityId).then((coworkOffers) => {
            // Update the state
            this.setState({...this.state, coworkOffers});
            
            // Render offers
            this.renderOffers(this.state.coworkOffers);
        });
    }

    fetchOffers(cityId) {
        // Render offers
        return fetch(`/homes/re2/coworkOffers?cityId=${cityId}`).then((res) => res.json());
    }

    /**
     * Renders offers
     * @param {Array} offers 
     */
    renderOffers(coworkOffers = []) {

        this.refs.coworkOffers.innerHTML = coworkOffers.reduce((html, response) => html + `
        <a href="${this.getUrl(response)}" class="cw_offer_tile">
            <div class="cw_offer_tile_top">
                <div class="cw_offer_img_wrapper">
                    ${this.getImageUrl(response)}
                </div>
                <h3>${response.propertyName}</h3>
                <p class="cw_offer_loc">${response.localityName}, ${response.cityName}</p>
                <div class="offer_box mrtp10">Offers Inside</div>
            </div>
            <div class="cw_offer_tile_bottom">
                <p>${response.description} <span>Read More</span></p>
                <div class="cw_offer_link" href="">View Offer <svg class="icon-right-arrow" width="14px" height="14px"><use xlink:href="#icon-right-arrow"></use></svg></div>
            </div>
        </a>`, '');

        if(isEmpty(this.refs.coworkOffers.innerHTML)){
            document.getElementById("offersSection").classList.add('hide');
        }
        
    }

    getImageUrl(response) {
        if(response.media && response.media.length>0 ) {
            let image = response.media[0].url.replace("80x80","300x300");
            return `<img src="${image}" />`;
        } else {
            return `<img class="defualt_img" src="${window.CDNURL}/image/QC_DefaultImage.jpg" />`
        }
    }


    /**
     * generate urls for vap page
     */
    getUrl(response){
        let locality = (response.localityName).replace(/\s+/g, '-').toLowerCase();
        let city = (response.cityName).replace(/\s+/g, '-').toLowerCase();
        let propertyName = (response.propertyName).replace(/\s+/g, '-').toLowerCase();
        return `//www.quikr.com/coworking/listing/${propertyName}-${locality}-${city}-${response.id}`;
    }




}